import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import FlagIcon from '@mui/icons-material/Flag';
import { v4 as uuidv4 } from 'uuid';
import '../../../../Assets/Styles/Containers/_button.scss';
import '../../../../Assets/Styles/Containers/_inspection.scss';
import '../../../../Assets/Styles/Containers/_lines.scss';
import { GetUTCTime } from '../../../Helpers/GetUTCTime';
import { UpdateTemplateDataSpecific } from '../../../Helpers/ApiCall';
import { cleanPayloadOnCommentICLevel, cleanPayloadOnLineLevel } from '../../../Helpers/HelperFunctions';
import { resolveRemovedDefaultRatingId } from '../../../Helpers/LineRatingUtils';

const AddRatingModal = (props) => {
  const { showRatingModal, setShowRatingModal, ratings, templateId, categoryId, lineUuid, commentUuid, component, ratingValue, setRatingValue } = props
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [selectedRatingIdentifiers, setSelectedRatingIdentifiers] = useState([])
  const [inspectionResponse, setInspectionResponse] = useState();
  const [ratingPresent, setRatingPresent] = useState(false);
  const templateData = useSelector((state) => state.CommonReducer);
  const [refresh, setRefresh] = useState(false)
  let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex(itm => itm.template_id === templateId);
  const ratingData = templateData?.inspectionData?.data?.inspectiontemplates[templateIndex]?.rating_data;

  const getRatingIdentifier = (rating) => {
    return `${rating?.Name}-${rating?.Color}`;
  };

  const dispatch = useDispatch();
  const storeData = useSelector((state) => state.CommonReducer);
  const handleClose = () => {
    setShowRatingModal(false)
  }
  const handleRatingSelection = (rating) => {
    setSelectedRatings(prev => {
      let index = prev?.findIndex(el => getRatingIdentifier(el) === getRatingIdentifier(rating));
      if (index === -1) prev?.push(rating)
      else prev?.splice(index, 1)
      return prev
    })
    setSelectedRatingIdentifiers(selectedRatings?.map(rating => getRatingIdentifier(rating)))
    setRefresh(prev => !prev)
    if (selectedRatings?.length === 1 && !ratingPresent) { (component === "line_outside" || component === "line_inside") ? saveLineLevelRating() : saveRatings() }
  }
  const clearRatingHandle = () => {
    setSelectedRatings([]);
    setSelectedRatingIdentifiers([])
    setRefresh(prev => !prev)
  }
  const saveRatings = async () => {
    if (component === "commentModal") {
      if (ratingValue?.length < 0) {
        setRatingValue(selectedRatings);
      } else {
        setRatingValue(selectedRatings);
      }
    } else {
      let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex(itm => itm.template_id === templateId);
      let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex(itm => itm.id === categoryId);
      let lineIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex(line => line.uuid === lineUuid)
      let prevData = JSON.parse(JSON.stringify(inspectionResponse));
      delete prevData?.report_media_library_files;
      let commentIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex(
        (itm) => itm.uuid == commentUuid
      );
      let ratingIndex = inspectionResponse?.inspectiontemplates[templateIndex].categories[
        categoryIndex
      ].lines[lineIndex].comments[
        commentIndex
      ].comment_input_controls.findIndex((itm) => itm.type == "Rating");
      if (ratingIndex < 0) {
        let ratingObject = {
          comment_input_control_id: null,
          uuid: uuidv4(),
          prompt: "Rating",
          values: [],
          type: "Rating",
          data: selectedRatings,
          updated_at: await GetUTCTime(),
          created_at: await GetUTCTime(),
        };
        prevData.inspectiontemplates[templateIndex].categories[
          categoryIndex
        ].lines[lineIndex].comments[
          commentIndex
        ].comment_input_controls.push(ratingObject);
        ratingIndex = prevData.inspectiontemplates[templateIndex].categories[
          categoryIndex
        ].lines[lineIndex].comments[
          commentIndex
        ].comment_input_controls.findIndex((itm) => itm.type == "Rating");
      } else {
        prevData.inspectiontemplates[templateIndex].categories[
          categoryIndex
        ].lines[lineIndex].comments[commentIndex].comment_input_controls[
          ratingIndex
        ].data = selectedRatings;
        prevData.inspectiontemplates[templateIndex].categories[
          categoryIndex
        ].lines[lineIndex].comments[commentIndex].comment_input_controls[
          ratingIndex
        ].updated_at = await GetUTCTime();
      }
      // Remember when the template default was taken off this comment so it stays off.
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[
        commentIndex
      ].removed_default_rating_id = resolveRemovedDefaultRatingId(selectedRatings, ratingData);
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[
        commentIndex
      ].updated_at = await GetUTCTime();
      let filteredObject = cleanPayloadOnCommentICLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, ratingIndex);
      UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    }
    setShowRatingModal(false);
  }
  const saveLineLevelRating = async () => {
    let templateIndex = inspectionResponse?.inspectiontemplates?.findIndex(itm => itm.template_id === templateId);
    let categoryIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories?.findIndex(itm => itm.id === categoryId);
    let lineIndex = inspectionResponse?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex(line => line.uuid === lineUuid)
    let prevData = JSON.parse(JSON.stringify(inspectionResponse));
    delete prevData?.report_media_library_files;
    let newRatings = selectedRatings.map(rating => {
      return {
        Id: rating?.Id,
        Name: rating?.Name,
        Color: rating?.Color,
        include_in_summary: rating?.include_in_summary
      }
    })
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].line_rating_data = newRatings;
    // Remember when the template default was taken off this line so it stays off.
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].removed_default_rating_id =
      resolveRemovedDefaultRatingId(newRatings, ratingData);
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].updated_at = await GetUTCTime();
    let filteredObject = cleanPayloadOnLineLevel(prevData, templateIndex, categoryIndex, lineIndex);
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setShowRatingModal(false);
  }

  useEffect(() => {
    setSelectedRatings(prev => prev);
  }, [refresh])

  useEffect(() => {
    if (storeData.inspectionData) {
      setInspectionResponse(storeData.inspectionData?.data)
    }
  }, [storeData?.inspectionData])

  useEffect(() => {
    let currentRatings = Array.isArray(ratings) ? ratings?.map(rating => rating) : [];
    if ((component === "commentModal" && ratingValue && ratingValue?.length !== 0) || (currentRatings && currentRatings?.length !== 0)) setRatingPresent(true)
    else setRatingPresent(false);
    setSelectedRatings((component === "commentModal" ? ratingValue : currentRatings) || []);
    setSelectedRatingIdentifiers(component === "commentModal" ? ratingValue?.map(rating => getRatingIdentifier(rating)) : currentRatings?.map(rating => getRatingIdentifier(rating)))
  }, [showRatingModal])

  return (
    <Dialog className='dialog-container-new-category'
      open={showRatingModal}
      onClose={handleClose}
      aria-labelledby="category-modal"
      aria-describedby="category-modal-description"
    >
      <div className="close-wrapper-new-line">
        <CloseIcon onClick={handleClose} />
      </div>
      <DialogTitle className='editor-dialog-title'>{"Add Rating"}</DialogTitle>
      {component !== "line_outside" && component !== "line_inside" ? <span className='category-dialog-subtitle'>Flagged ratings will go to summary.  </span> : null}
      <DialogContent className="dialog-content-new-category">
        <Grid container className="input-controll">
          <Grid item xs={12} >
            {ratingData?.map((rating, index) => (
              <Typography onClick={() => handleRatingSelection(rating)} key={index}
                className={`bordered__text ${selectedRatingIdentifiers?.includes(getRatingIdentifier(rating)) && 'cat_selected'}`}>
                <span className="rating_square_container"><span className="rating_square" style={{ background: `${rating.Color}` }}>{parseInt(rating.include_in_summary) ? <FlagIcon /> : null}</span>
                  <span className='rating_bordered__text__content'>{rating.Name}</span></span>
                <DoneIcon className='cat_seleted_icon' />
              </Typography>
            ))}
          </Grid>
          {ratingPresent && <p className="clear_rating" onClick={() => { clearRatingHandle() }}><span>Clear rating</span></p>}
        </Grid>
      </DialogContent>
      {ratingPresent ? <DialogActions className='new-category-modal-action'>
        <Button className="add-category-btn" onClick={() => (component === "line_outside" || component === "line_inside") ? saveLineLevelRating() : saveRatings()}>Done</Button>
      </DialogActions> : ""}
    </Dialog>
  )
}

export default AddRatingModal